import { ParameterTypeEnum } from '../../enums/parameterType.enum';

export const VOLUME_UNIT = 'L';

export const STATIC_PARAMETER_UNITS: Partial<Record<ParameterTypeEnum, string>> = {
  [ParameterTypeEnum.Humidity]: '%',
  [ParameterTypeEnum.BatteryPercentage]: '%',
  [ParameterTypeEnum.SignalStrength]: '%',
  [ParameterTypeEnum.Lavg]: 'db',
  [ParameterTypeEnum.WindDirection]: 'deg',
  [ParameterTypeEnum.ChargingCurrent]: 'A',
  [ParameterTypeEnum.SystemCurrent]: 'A',
  [ParameterTypeEnum.BatteryVoltage]: 'V',
  [ParameterTypeEnum.ChargingVoltage]: 'V'
};
